module.exports = __webpack_public_path__ + "ai.jpg?7ef2ca0f70dcd13a1cd0b3fcd5c7653f";